import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function HomePage() {
  const { ready, token } = useAuth();
  if (!ready) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" />
      </div>
    );
  }
  if (token) return <Navigate to="/dashboard" replace />;

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark public-hero">
        <div className="container">
          <Link className="navbar-brand" to="/">
            M3UStudio
          </Link>
          <div className="ms-auto d-flex gap-2 align-items-center">
            <Link className="btn btn-light btn-sm rounded-pill px-3" to="/login">
              Sign in
            </Link>
            <Link className="btn btn-outline-light btn-sm rounded-pill px-3" to="/register">
              Sign up
            </Link>
          </div>
        </div>
      </nav>
      <section className="public-hero text-white py-5">
        <div className="container py-5">
          <div className="row align-items-center gy-4">
            <div className="col-lg-6">
              <h1 className="display-6 fw-bold">Your playlists, made easier</h1>
              <p className="lead opacity-90">
                Manage M3U playlists and EPG in one place — built for the same API and database as your
                current deployment.
              </p>
              <Link to="/register" className="btn btn-light rounded-pill px-4 py-2 fw-semibold">
                Get started
              </Link>
            </div>
            <div className="col-lg-6 text-center">
              <div className="rounded-4 bg-white bg-opacity-10 p-5">React dashboard + PHP API</div>
            </div>
          </div>
        </div>
      </section>
      <footer className="border-top py-4 text-center text-muted small">
        © {new Date().getFullYear()} M3UStudio
      </footer>
    </div>
  );
}
